import { createRoot } from 'react-dom/client';
import { AnalyticsProvider } from 'use-analytics';

import PackWrapper from 'components/common/PackWrapper';
import FunnelContainer from 'components/signUpFunnel/FunnelContainer';
import pixelAnalytics from 'helpers/analytics/pixelAnalytics';
import { getStore } from 'store/configure';
import { getBrowserHistory } from 'utilities/router';

const store = getStore();
const history = getBrowserHistory();

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.querySelector('#hc-sign-up-funnel-react-app');
  const root = createRoot(rootElement);

  root.render(
    <PackWrapper rootElement={rootElement} store={store} history={history}>
      <AnalyticsProvider
        instance={pixelAnalytics({
          canTrack: rootElement?.getAttribute('data-can-track') === 'true',
        })}
      >
        <FunnelContainer />
      </AnalyticsProvider>
    </PackWrapper>
  );
});
